// extracted by mini-css-extract-plugin
module.exports = {"container":"container__nW7Om","fontSize":"fontSize__31o1p"};